import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import styled from "@emotion/styled";
import { Input, Select, Space } from "antd";
import { t } from "i18next";
import { useCallback, useEffect, useState } from "react";
import { PropsEntity } from "../../../common/entity/props.entity";
import { ActivityRechargesEntity } from "../../activity/entity/activity.entity";
import { CouponEntity } from "../entity/coupon.entity";
import couponService from "../service/coupon.service";
const { Option } = Select;

interface RechargeProps extends PropsEntity {
	value?: ActivityRechargesEntity[];
}

export const RechargeCoupons = (props: RechargeProps) => {
	const [couponArr, setCouponArr] = useState<CouponEntity[]>([]);
	const [couponTitle, setCouponTitle] = useState<string>("");
	const [rechargeArr, setRechargeArr] = useState<ActivityRechargesEntity[]>([]);
	const [recharge, setRecharge] = useState<ActivityRechargesEntity>({
		money: 0,
		giveMoney: 0,
		couponId: "",
		couponName: "",
	});

	const couponList = useCallback(async () => {
		const { data } = await couponService.noAuth({ title: couponTitle, type: 1, isDisplay: 1 });
		setCouponArr(data.data.list);
	}, [couponTitle]);

	useEffect(() => {
		console.log(props.value);
		setRechargeArr(props.value ?? []);
		couponList();
	}, [couponList, props.value]);

	const addItem = () => {
		const arr = rechargeArr?.concat();
		arr?.push({ ...recharge });
		setRechargeArr(arr);
		setRecharge({
			money: 0,
			giveMoney: 0,
			couponId: "",
			couponName: "",
		});
		props.onChange && props.onChange(arr);
	};

	const remove = (index: number) => {
		const arr = rechargeArr?.concat();
		arr?.splice(index, 1);
		setRechargeArr(arr);
		props.onChange && props.onChange(arr);
	};

	return (
		<Container>
			<div className='select'>
				<Space>
					<div>
						<Input
							placeholder={t("please.enter.recharge.amount")}
							value={recharge.money}
							onChange={(e) => {
								setRecharge({ ...recharge, money: Number(e.target.value) });
							}}
						/>
					</div>
					<div>
						<Input
							value={recharge.giveMoney}
							placeholder={t("please.enter.gift.amount")}
							onChange={(e) => {
								setRecharge({ ...recharge, giveMoney: Number(e.target.value) });
							}}
						/>
					</div>
					<div>
						<Select
							style={{ width: 200 }}
							placeholder='请选择优惠券'
							allowClear
							showSearch
							value={recharge.couponId ? recharge.couponId.split(",").map(Number) : []}
							mode='multiple'
							onSearch={setCouponTitle}
							optionFilterProp={"children"}
							onChange={(e: any, f: any) => {
								console.log(e, f);
								setRecharge({ ...recharge, couponId: e.join(","), couponName: f.map((item: any) => item.children).join(",") });
							}}
						>
							{couponArr.map((item) => {
								return (
									<Option key={item.id} value={item.id}>
										{item.title}
									</Option>
								);
							})}
						</Select>
					</div>
					<PlusOutlined style={{ color: "#096dd9" }} onClick={addItem} />
				</Space>
			</div>

			<div>
				{rechargeArr &&
					rechargeArr.map((item, index) => {
						return (
							<div key={index}>
								充值 {item.money}元/赠送 {item.giveMoney}元/{item.couponName ? item.couponName + "优惠券" : ""}
								<MinusOutlined style={{ color: "#f5222d" }} onClick={() => remove(index)} />
							</div>
						);
					})}
			</div>
		</Container>
	);
};

const Container = styled.div`
	width: 100%;
	.select {
		display: flex;
	}
`;
